module.exports = __webpack_public_path__ + "static/assets/ee497ac9cacc4c8eb99893d8d0c679e7.png";